import { Router } from '@angular/router';
import { apiUrl } from './../app.config';
import {
  Http,
  Headers,
  Response,
  URLSearchParams,
  RequestOptionsArgs,
  RequestOptions,
  ResponseContentType
} from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription, Subject, BehaviorSubject } from 'rxjs/Rx';
import { StaffDetail } from './../models/staffLogin';
import { DataService } from './data.service';
import { PlanMainService } from '../plan/service/plan-main.service';

@Injectable()
export class LoginService {
  static headers = new Headers({ 'Content-Type': 'application/json' });
  public subScription: Subscription;
  public staffSubScription: Subscription;
  public ngUnsubscribe = new Subject();
  public defaultHeaders: Headers = new Headers();
  public isLogout = new BehaviorSubject<boolean>(false);

  constructor(private http: Http, private router: Router, private _data: DataService,
    private _planmainService: PlanMainService) { }

  checkLogin(user: any) {
    const body = JSON.stringify(user);
    return this.http
      .post(`${apiUrl}/auth/token`, body, { headers: LoginService.headers })
      .map(response => response.json())
      .catch(this.handleError);
  }

  refreshToken(token: string) {
    const headers = LoginService.headers;
    headers.set('auth', token);
    // console.log(headers);
    return Observable.timer(0, 1 * 60 * 1000) // 4 mins
      .flatMap(() =>
        this.http.put(`${apiUrl}/auth/token`, '', { headers: headers })
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  isAuthenticated() {
    if (this._data.token) {
      this.subScription = this.refreshToken(
        this._data.token
      ).subscribe(
        data => console.log(data),
        error => this.checkLogout().subscribe(),
        () => { }
      );

      return this.subScription;
    } else {
      return false;
    }
  }

  clearDataAndNavigateToLogin(isLogout:boolean = false) {
    let rememberId = '';
    if (this.subScription) {
      this.subScription.unsubscribe();
    }
    if (this._data.idRemember) {
      rememberId = this._data.idRemember;
    }
    this._data.clearData();
    if (rememberId != '') {
      this._data.idRemember = rememberId;
    }
    if(!isLogout){
      this.router.navigate(['/login']);
    }
  }

  checkLogout() {
    const headers = LoginService.headers;
    headers.set('auth', this._data.token);
    this.clearDataAndNavigateToLogin(true);
    // return this.http
    //   .delete(`${apiUrl}/auth/token`, { headers: headers })
    //   .catch(this.handleError);
    const requestOptions: RequestOptionsArgs = {
      method: 'DELETE',
      headers: headers
    };
    return this.http
      .request(`${apiUrl}/auth/token`, requestOptions)
      .catch(this.handleError);
  }

  // ====================================//

  detailStaff(token: string) {
    const path = `${apiUrl}` + `/staff/auth`;
    const headers = LoginService.headers;
    headers.set('auth', token);
    headers.set('Content-Type', 'application/json');
    return this.http.get(path, { headers: headers });
  }

  // refreshStaffAuth(token: string) {
  //   return Observable.timer(0, 1 * 15 * 1000) // 15 sec
  //     .flatMap(() =>
  //       this.detailStaff(token)
  //     )
  //     .map(response => response.json())
  //     .catch(this.handleError);
  // }

  // isStaffAuthenticated(who?: string) {
  //   const token = this._data.token;
  //   const staffData = this._data.staffData;
  //   const subject = new Subject<boolean>();

  //   this.detailStaff(token)
  //     .map(response => response.json())
  //     .subscribe((res: StaffDetail) => {
  //       // console.log('res', res);
  //       // if (res && res.kyotenCd && !this._data.kyotenCd) {
  //       //   this._data.kyotenCd = res.kyotenCd;
  //       // }
  //       if (res && res.kyotenCd && res.kyotenNm && res.staffCd && res.staffNm && staffData) {
  //         if (this.staffSubScription) { this.staffSubScription.unsubscribe(); }
  //         this.staffSubScription = this.refreshStaffAuth(token)
  //           .takeUntil(this.ngUnsubscribe)
  //           .subscribe(
  //             (data: StaffDetail) => {
  //               if (data && data.kyotenCd && data.kyotenNm && data.staffCd && data.staffNm) {
  //                 // subject.next(true);
  //                 // console.log({ isStaffLogin: true, who: who });
  //                 if (this._data.staffData && !this._data.staffData.shatenCd &&
  //                   (who === 'dialogstaff' || who === 'header')) {
  //                   const staff = {...this._data.staffData};
  //                   this._data.staffData = {...staff, ...data};
  //                 }
  //               } else {
  //                 // subject.next(false);
  //                 // console.log({ isStaffLogin: false, who: who });
  //                 this.clearDataAndNavigateToLoginStaff();
  //               }
  //             },
  //             error => {
  //               console.log(error);
  //               this.clearDataAndNavigateToLoginStaff();
  //             });
  //         subject.next(true);
  //         // if (this.router.url === '/home') {

  //         // }
  //         // console.log('​LoginService->', true);
  //         return this.staffSubScription;
  //       } else {
  //         subject.next(false);

  //         // console.log('​LoginService->', false);
  //         if (this.router.url === '/home' || this.router.url === '/planmain') {
  //           this.clearDataAndNavigateToLoginStaff();
  //         } else {
  //           if (this.staffSubScription) { this.staffSubScription.unsubscribe(); }
  //         }

  //         return false;
  //       }
  //     });


  //   return subject.map(e => {
  //     return e;
  //   });



  //   // if (staffData) {
  //   //   if (this.staffSubScription) { this.staffSubScription.unsubscribe(); }
  //   //   this.staffSubScription = this.refreshStaffAuth(token)
  //   //     .takeUntil(this.ngUnsubscribe)
  //   //     .subscribe(
  //   //       (data: StaffDetail) => {
  //   //         if (data && data.kyotenCd && data.kyotenNm && data.staffCd && data.staffNm) {
  //   //           // subject.next(true);
  //   //           console.log({ isStaffLogin: true, who: who });
  //   //         } else {
  //   //           // subject.next(false);
  //   //           console.log({ isStaffLogin: false, who: who });
  //   //           this.clearDataAndNavigateToLoginStaff();
  //   //         }
  //   //       },
  //   //       error => {
  //   //         console.error(error);
  //   //         this.clearDataAndNavigateToLoginStaff();
  //   //       });
  //   //   return this.staffSubScription;
  //   // } else {
  //   //   return false;
  //   // }

  // }

  isStaffAuthenticated(who?: string) {
    const token = this._data.token;
    const staffData = this._data.staffData;
    const subject = new Subject<any>();

    this.detailStaff(token)
      .map(response => response.json())
      .subscribe((res: StaffDetail) => {
        // console.log('res', res);
        // if (res && res.kyotenCd && !this._data.kyotenCd) {
        //   this._data.kyotenCd = res.kyotenCd;
        // }
        if (res && res.kyotenCd && res.kyotenNm && res.staffCd && res.staffNm && staffData) {
          const staff = {...this._data.staffData};
          this._data.staffData = {...staff, ...res};
          subject.next(res);

        } else {
          subject.next(res);
        }
      });


    return subject.map(e => {
      return e;
    });
  }

  stopRefreshStaffAuth() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  clearDataAndNavigateToLoginStaff() {
    // const staffData = localStorage.removeItem('staffData');

    if (this.staffSubScription) { this.staffSubScription.unsubscribe(); }
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this._data.removeData('staffData');

    this.isLogout.next(true);
    if (this.router.url === '/planmain' || this.router.url.indexOf('osusume') > -1) {
      this.router.navigate(['/home']);
    }
    this._planmainService.menuAutho.next(null);
  }

  // ====================================//

  private handleError(error: any) {
    console.log(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/login.service.ts